import React from "react"
import { useTranslation } from "react-i18next"

import {
  ProductPositionOverlay,
  ProductPositionOverlayViewModel
} from "../product-position-overlay/ProductPositionOverlay"

export type EditProductPositionOverlayViewModel = Omit<
  ProductPositionOverlayViewModel,
  "id" | "headline"
>

export const EditProductPositionOverlayView = React.memo(
  (props: EditProductPositionOverlayViewModel) => {
    const { t } = useTranslation()
    return (
      <ProductPositionOverlay
        {...props}
        id="edit-product-position-overlay"
        className="edit-product-position-overlay"
        prefix="product-position__edit"
        headline={t("ProductPosition.Actions.Update")}
      />
    )
  }
)
